(function () {
  function installExactEngravingSwatches() {
    if (
      typeof ACTIVE_FAMILY === 'undefined' ||
      typeof STATE === 'undefined' ||
      typeof isAvailable !== 'function' ||
      typeof switchProductFromSwatch !== 'function'
    ) {
      return false;
    }

    function renderExactEngravingSwatches(product) {
      const colorSection = document.getElementById('colorSection');
      const colorContainer = document.getElementById('colorContainer');
      if (!colorSection || !colorContainer || !product) return;

      const productsForCurrentTip = ACTIVE_FAMILY.filter(
        candidate => candidate._tip === STATE.tip && isAvailable(candidate)
      );

      const optionMap = new Map();
      productsForCurrentTip.forEach(candidate => {
        if (!candidate._swatchImage || !candidate._swatchKey) return;
        if (!optionMap.has(candidate._swatchKey)) {
          optionMap.set(candidate._swatchKey, candidate);
        }
      });

      const swatchOptions = [...optionMap.values()].sort((a, b) => {
        const labelCompare = String(a._extractedColor || '').localeCompare(String(b._extractedColor || ''));
        if (labelCompare !== 0) return labelCompare;
        return String(a._swatchKey || '').localeCompare(String(b._swatchKey || ''));
      });

      if (swatchOptions.length <= 1) {
        colorContainer.innerHTML = '';
        colorSection.style.display = 'none';
        return;
      }

      colorSection.style.display = 'block';
      colorContainer.innerHTML = swatchOptions.map(target => {
        const isSelected = !!(
          target._swatchKey &&
          product._swatchKey &&
          target._swatchKey === product._swatchKey
        );
        const safeColor = typeof escapeHtml === 'function'
          ? escapeHtml(target._extractedColor || 'Color')
          : String(target._extractedColor || 'Color');
        const safeImage = typeof escapeHtml === 'function'
          ? escapeHtml(target._swatchImage)
          : String(target._swatchImage);

        return `
          <div
            class="cross-swatch ${isSelected ? 'selected' : ''}"
            style="background-color:transparent;"
            title="${safeColor}"
            onclick="switchProductFromSwatch(${target.id})"
          >
            <img src="${safeImage}" alt="${safeColor}" loading="eager">
          </div>
        `;
      }).join('');

      if (typeof updateAllCarousels === 'function') {
        window.setTimeout(updateAllCarousels, 0);
      }
    }

    if (typeof render === 'function' && !render.__crossExactSwatchesWrapped) {
      const originalRender = render;
      const wrappedRender = function (product) {
        originalRender(product);
        renderExactEngravingSwatches(product);
      };
      wrappedRender.__crossExactSwatchesWrapped = true;
      render = wrappedRender;
    }

    const currentProduct = ACTIVE_FAMILY.find(
      candidate => String(candidate.id) === String(STATE.productId)
    );
    if (currentProduct) renderExactEngravingSwatches(currentProduct);

    return true;
  }

  if (installExactEngravingSwatches()) return;

  let attempts = 0;
  const timer = window.setInterval(() => {
    attempts += 1;
    if (installExactEngravingSwatches() || attempts >= 40) {
      window.clearInterval(timer);
    }
  }, 50);
})();
